import React, {ReactNode, useMemo, useState} from 'react';
import {NumpadExtended} from '../components/NumpadExtended';

type SpecialKeysType = { [key: string]: ReactNode | string };

const defaultSpecialKeys: SpecialKeysType = {
    "*": "*",
    "#": "#",
};

export function useNumpadExtended(disabled: boolean, specialKeys: SpecialKeysType = {}, onKeyPressed?: (key: string, input: string) => void): [() => ReactNode, string, (name: string) => void] {
    const [input, setInput] = useState('');
    const getInput = useMemo(
        () => input ? input : '',
        [input],
    );

    const keyPad = (key: string) => {
        if (disabled) {
            if (input !== '') {
                setInput('');
            }
            return;
        }

        if (onKeyPressed) {
            onKeyPressed(key, input);
        }

        if (key === '#') {
            if (input.length === 0) {
                return;
            }
            setInput(input => input.substring(0, input.length - 1));
        } else if (key === "*") {
            return;
        } else {
            if (input.length >= 4) {
                return;
            }
            setInput(input => input + key);
        }
    };

    const renderNumpad = () => {
        return (
            <NumpadExtended hash={getInput} onKeyPress={keyPad} specialKeys={{...defaultSpecialKeys, ...specialKeys}}/>
        );
    };

    return [renderNumpad, input, setInput];
}
